export const PageType = {
  CHECKOUT: 'checkout',
  UPSELL: 'upsell',
  CONFIRMATION: 'confirmation',
  OTHER: 'other',
};
export const ENVIRONMENT = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
  STAGING_CF: 'staging-cf',
  PRODUCTION_CF: 'production-cf',
};

export const DESIGN_ID_ENABLED_STORES = ['9ff43a-25'];
